import { Search, CalendarCheck, ShieldCheck } from "lucide-react";
import { solution } from "../content/site";
import { Container, Reveal, SectionHeading, Stagger, StaggerItem } from "./ui";

const ICONS = [Search, CalendarCheck, ShieldCheck];

export default function SolutionSection() {
  return (
    <section className="bg-white py-20 sm:py-28">
      <Container>
        <Reveal>
          <SectionHeading title={solution.headline} body={solution.body} />
        </Reveal>

        <Stagger className="mt-16 grid gap-6 md:grid-cols-3">
          {solution.cards.map((card, idx) => {
            const Icon = ICONS[idx];
            return (
              <StaggerItem key={card.number}>
                <div className="group relative h-full overflow-hidden rounded-[28px] border border-navy/8 bg-[var(--color-bg-soft)] p-8 transition-all duration-300 hover:-translate-y-1.5 hover:shadow-navy">
                  <span className="text-6xl font-extrabold text-navy/[0.06] transition-colors group-hover:text-primary/10">
                    {card.number}
                  </span>
                  <div className="mt-2 flex h-14 w-14 items-center justify-center rounded-2xl bg-primary text-white shadow-[0_10px_24px_-8px_rgba(255,74,0,0.5)]">
                    <Icon size={26} />
                  </div>
                  <h3 className="mt-6 text-2xl font-extrabold tracking-tight text-navy">
                    {card.title}
                  </h3>
                  <p className="mt-3 text-base text-navy/60">{card.text}</p>
                </div>
              </StaggerItem>
            );
          })}
        </Stagger>
      </Container>
    </section>
  );
}
